import { GenericLink, LoaderType, NextgenImage, useBreakpoint } from '@nextgen-web-framework/all';
import { getThemeColorClass, ThemeColor, ThemeShades, ThemeColorType, ThemeShadesType } from '../../utils/themeColor';
import styles from '../ContentCard/ContentCard.module.scss';
import { type ArticleCardProps } from './types/propsTypes';

const ArticleCard = (props: ArticleCardProps) => {
  const viewPortType = useBreakpoint();
  const bannerImage = props?.imageList?.find((item) => item?.viewport?.includes(viewPortType));

  //get theme color from props
  const themeColor = props.themeColor
    ? getThemeColorClass(
        ThemeColor[props.themeColor as ThemeColorType],
        (props.themeShade as ThemeShadesType) || ThemeShades.dark,
      )
    : undefined;
  const theme = themeColor || `card-bg-color-${props.backgroundColor || 'white'}`;
  const txtColor = themeColor ? '' : `card-color-${props.color || 'black'}`;

  const articleContent = () => (
    <>
      <div data-testid={`article-card-container-testid`} className={`${styles['content-card-container']}`}>
        <div className={styles['banner']}>
          {bannerImage?.url && (
            <NextgenImage loaderType={LoaderType.CONTENTSTACK} alt={bannerImage?.altText ?? ''} src={bannerImage.url} />
          )}
        </div>
        <div className={`${styles['content']} ${styles[theme]} ${styles[txtColor]}`}>
          <div className={styles['header']}>
            <div className={styles['tag']}>{props.tag}</div>
            {props.title && (
              <div title={props.title} className={styles['title']}>
                {props.title}
              </div>
            )}
          </div>
          {props.description && <div className={styles['description']}>{props.description}</div>}
          <div className={styles['footer']}>
            {props.subTitle && <div className={styles['footer-line']}>{props.subTitle}</div>}
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      {props?.url ? (
        <GenericLink className={styles['content-card-link']} href={props.url ?? ''} target={props.target}>
          {articleContent()}
        </GenericLink>
      ) : (
        articleContent()
      )}
    </>
  );
};

export default ArticleCard;
export { ArticleCardProps };
